import React from 'react';

function ChamadoEmailField({ value, onChange, id = 'chamado-email' }) {
    return (
        <div className="chamado-create-field">
            <label htmlFor={id}>E-mail adicional para envio</label>
            <input
                id={id}
                type="email"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="nome@email.com"
            />
        </div>
    );
}

export default ChamadoEmailField;
